import Debug from 'debug'
import { injectable, inject } from 'inversify';
import { CommandHandler } from '@/app/tracking/api';
import { ErrorHandlingScorm2004Client, ErrorHandlingScorm2004ClientSymbol } from '@/app/tracking/scorm/2004/client';
import { CompleteCourseCommandPayload,
         CompleteCourseCommand } from '../api';

const debug = Debug('scorm2004-complete-course-command-handler')

@injectable()
export class Scorm2004CompleteCourseCommandHandler implements CommandHandler<CompleteCourseCommand> {

  constructor(
    @inject(ErrorHandlingScorm2004ClientSymbol)
    private readonly client: ErrorHandlingScorm2004Client) {
  }

  public async execute(command: CompleteCourseCommandPayload) {

    debug('execute', command)
    const currentStatus = await this.client.getValue('cmi.completion_status')
    debug('current status', currentStatus)
    const currentSuccessStatus = await this.client.getValue('cmi.success_status')
    debug('current success status', currentSuccessStatus)

    if (currentStatus.success && currentStatus.value === 'completed' &&
          currentSuccessStatus.success && currentSuccessStatus.value === command.successStatus) {

      debug('completion and success status not changed, returning')
      return
    }

    console.log('completing course with passed success_status')
    debug('completing course with passed success_status')

    const items: Array<[string, any]>  = [
      [ 'cmi.success_status', command.successStatus ],
      [ 'cmi.completion_status', 'completed' ]
    ];

    this.client.setValues(items);
    this.client.commit();
  }
}
